import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TooltipModule, PopoverModule } from 'ngx-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgSelectModule } from '@ng-select/ng-select';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { WorkLocationsIconModule } from 'src/app/shared/work-locations-icon/work-locations-icon.module';
import { CandidateCardIconsModule } from 'src/app/shared/candidate-card-icons/candidate-card-icons.module';
import { CandidateActionsModule } from 'src/app/shared/candidate-actions/candidate-actions.module';
import { ModalModule } from 'ngx-bootstrap';
import { AssociateCandidatesActionsModalModule } from './associate-candidates-actions-modal/associate-candidates-actions-modal.module';
import { CandidateSendOutreachEmailModalModule } from '../candidate-send-outreach-email-modal/candidate-send-outreach-email-modal.module';
import { AssociateCandidatesComponent } from './associate-candidates.component';

@NgModule({
  declarations: [AssociateCandidatesComponent],
  imports: [
    CommonModule,
    FormsModule,
    TooltipModule,
    PopoverModule.forRoot(),
    InfiniteScrollModule,
    NgSelectModule,
    PipesModule,
    WorkLocationsIconModule,
    CandidateCardIconsModule,
    CandidateActionsModule,
    ModalModule.forRoot(),
    AssociateCandidatesActionsModalModule,
    CandidateSendOutreachEmailModalModule
  ],
  exports: [AssociateCandidatesComponent],
  entryComponents: [AssociateCandidatesComponent]
})
export class AssociateCandidatesModule { }
